import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  landinglayout: {
    width: "1024px",
    margin: "0 auto",
    padding: "0 16px",
    "@media(max-width: 1024px)": {
      width: "100%"
    }
  }
}));

const LandingLayout = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.landinglayout}>{children}</div>;
};

export default LandingLayout;
